import { useRef } from "react";
import { fmtClock } from "../lib/format";

export function SeekBar({ position = 0, duration = 0, onSeek, loop, testid }) {
  const barRef = useRef(null);
  const pct = duration > 0 ? (position / duration) * 100 : 0;

  const seekFromEvent = (clientX) => {
    const el = barRef.current;
    if (!el || duration <= 0) return;
    const rect = el.getBoundingClientRect();
    const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
    onSeek?.(ratio * duration);
  };

  const onDown = (e) => {
    e.preventDefault();
    const move = (ev) => seekFromEvent(ev.touches ? ev.touches[0].clientX : ev.clientX);
    move(e.nativeEvent);
    const up = () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseup", up);
      window.removeEventListener("touchmove", move);
      window.removeEventListener("touchend", up);
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseup", up);
    window.addEventListener("touchmove", move, { passive: false });
    window.addEventListener("touchend", up);
  };

  const loopL = loop && duration > 0 ? (loop.a / duration) * 100 : null;
  const loopW = loop && duration > 0 ? ((loop.b - loop.a) / duration) * 100 : null;

  return (
    <div data-testid={testid}>
      <div
        ref={barRef}
        onMouseDown={onDown}
        onTouchStart={onDown}
        style={{ position: "relative", height: 22, display: "flex", alignItems: "center", cursor: "pointer", touchAction: "none" }}
      >
        <div style={{ position: "relative", width: "100%", height: 6, borderRadius: 999, background: "var(--surface-3)", overflow: "hidden" }}>
          {loopL !== null ? (
            <div style={{ position: "absolute", top: 0, bottom: 0, left: `${loopL}%`, width: `${loopW}%`, background: "var(--warning)", opacity: 0.55 }} />
          ) : null}
          <div style={{ position: "absolute", top: 0, bottom: 0, left: 0, width: `${pct}%`, background: "var(--brand-primary)" }} />
        </div>
        <div style={{ position: "absolute", left: `calc(${pct}% - 7px)`, width: 14, height: 14, borderRadius: 999, background: "var(--on-surface)", boxShadow: "0 0 0 3px var(--surface-2)" }} />
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", color: "var(--muted)", fontSize: 11, fontFamily: "var(--f-medium)", fontVariantNumeric: "tabular-nums", marginTop: 2 }}>
        <span>{fmtClock(position)}</span>
        <span>{fmtClock(duration)}</span>
      </div>
    </div>
  );
}
